import { toast } from 'sonner';

import { ApiError } from '@/lib/api';
import { track, trackException } from '@/lib/telemetry';

/**
 * The one path for surfacing a handled error to the user. Beyond the toast it
 * emits the `friction.error_shown` signal (surface only — never the message
 * text, which can carry user data) and logs the error to error tracking, so
 * "how often do users SEE an error, and where" is answerable.
 *
 * `surface` is a stable snake_case id of where the error showed (e.g.
 * 'transactions', 'billing'), not a route: toasts outlive navigations.
 */
export function notifyError(surface: string, error: unknown, fallbackMessage: string): void {
  track('friction.error_shown', { surface });
  // `error` may be null at call sites whose catch discards the exception.
  if (error != null) trackException(error, { surface, handled: true });
  toast.error(error instanceof ApiError && error.message ? error.message : fallbackMessage);
}
